module.exports = __webpack_public_path__ + "static/Contact-e1bae479f910d64cbaf9490ecb639037.png";